export const createThumbnail = async (file: File): Promise<string> => {
  // Check if file is an image
  if (!file.type.startsWith('image/')) {
    return Promise.reject('File must be an image');
  }

  // Create a FileReader to read the file
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();

      img.onload = () => {
        // Define thumbnail dimensions
        const maxWidth = 240;
        const maxHeight = 200;

        // Calculate new dimensions while maintaining aspect ratio
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height = Math.round(height * (maxWidth / width));
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round(width * (maxHeight / height));
            height = maxHeight;
          }
        }

        // Create canvas and context
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        // Draw resized image to canvas with better quality
        const ctx = canvas.getContext('2d', { alpha: false });
        if (!ctx) {
          reject(new Error('Failed to get canvas context'));
          return;
        }

        // Set image smoothing for better quality
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        // Draw the image
        ctx.drawImage(img, 0, 0, width, height);

        // Get data URL from canvas with high quality
        const thumbnailDataUrl = canvas.toDataURL(file.type, 0.95);
        resolve(thumbnailDataUrl);
      };

      img.onerror = () => {
        reject(new Error('Failed to load image'));
      };

      // Set image source to FileReader result
      if (event.target?.result) {
        img.src = event.target.result as string;
      } else {
        reject(new Error('Failed to read file'));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    // Read file as data URL
    reader.readAsDataURL(file);
  });
};
